import { hot } from 'react-hot-loader/root'
import React, {
    Component
} from 'react'
import {
    withRouter,
    BrowserRouter as Router,
    Route,
    Link,
    Switch
} from 'react-router-dom'
import {
    connect,
    Provider
} from 'react-redux'
import {
    ConnectedRouter
} from 'connected-react-router'
import { ModalContainer, ModalRoute } from 'react-router-modal'
import pathToRegexp from 'path-to-regexp';

import AppNavigationContainer from './containers/app-navigation'
import LoginContainer from './containers/login'
import DashboardContainer from './containers/dashboard'
import StateDataContainer from './containers/state-data'
import ReportsContainer from './containers/reports'
import ReportDetailContainer from './containers/reports-detail'
import DepartmentsContainer from './containers/departments'
import DepartmentsDetailContainer from './containers/departments-detail'
import DepartmentsCreateEditContainer from './containers/departments-create-edit'
import UsersCreateEditContainer from './containers/users-create-edit'
import UsersDetailContainer from './containers/users-detail'

import ModalAssignReportToUser from './modals/reports-assign-user'
import ModalCreateReport from './modals/reports-create-report'
import ModalUploadCsvUsers from './modals/modal-upload-csv-users'
import ModalReportPhotosLightbox from './modals/modal-report-photos-lightbox'

// LEGACY @TODO
import LegacyReportsContainer from './containers/legacy/reports'
import LegacyReportDetailContainer from './containers/legacy/reports-detail'
import LegacyModalAssignReportToUser from './modals/legacy/reports-assign-user'
import LegacyModalCreateReport from './modals/legacy/reports-create-report'


const NotFound = () => {
  return (
    <div className="container">
        <h2>Page Not Found</h2>
    </div>
  );
};

const App = (props) => (
    <Provider store={props.store}>
        <ConnectedRouter history={props.history}>
            <div id="app-router">
                <Switch>
                    <Route exact path="/" component={LoginContainer}/>
                    <Route exact path="/login" component={LoginContainer}/>
                    <Route path="/app">
                        <AppNavigationContainer>
                            <Switch>
                                {/* LEGACY @TODO */}
                                <Route exact path="/app/legacy/reports/modal/create-report" component={LegacyReportsContainer}/>
                                <Route path="/app/legacy/reports/:report_id/:view" component={LegacyReportDetailContainer}/>
                                <Route path="/app/legacy/reports" component={LegacyReportsContainer}/>
                                {/* END LEGACY @TODO */}
                                {/* Any routes that may have a Modal must not be `exact` */}
                                <Route exact path="/app/dashboard" component={DashboardContainer}/>
                                <Route exact path="/app/reports/modal/create-report" component={ReportsContainer}/>
                                <Route path="/app/reports/:report_id/:view" component={ReportDetailContainer}/>
                                <Route path="/app/reports" component={ReportsContainer}/>
                                <Route exact path="/app/state-data" component={StateDataContainer}/>
                                <Route exact path="/app/departments" component={DepartmentsContainer}/>
                                <Route exact path="/app/departments/create" component={DepartmentsCreateEditContainer}/>
                                <Route exact path="/app/departments/:department_id" component={DepartmentsDetailContainer}/>
                                <Route exact path="/app/departments/:department_id/modal/upload-csv-users" component={DepartmentsDetailContainer}/>
                                <Route exact path="/app/departments/:department_id/edit" component={DepartmentsCreateEditContainer}/>
                                <Route exact path="/app/departments/:department_id/users/create" component={UsersCreateEditContainer}/>
                                <Route exact path="/app/departments/:department_id/users/:user_id" component={UsersDetailContainer}/>
                                <Route exact path="/app/departments/:department_id/users/:user_id/edit" component={UsersCreateEditContainer}/>
                                <Route component={NotFound}/>
                            </Switch>
                        </AppNavigationContainer>
                    </Route>
                    <Route component={NotFound}/>
                </Switch>
                <Switch>
                    <ModalRoute component={ModalAssignReportToUser} exact path={`/app/reports/modal/assign-user/:report_id`} parentPath={`/app/reports`} />
                    <ModalRoute component={ModalCreateReport} exact path={`/app/reports/modal/create-report`} parentPath={`/app/reports`} />
                    <ModalRoute component={ModalUploadCsvUsers} exact path={`/app/departments/:department_id/modal/upload-csv-users`} parentPath={match=>pathToRegexp.compile(`/app/departments/:department_id`)(match.params)}/>
                    <ModalRoute component={ModalReportPhotosLightbox} exact path={`/app/reports/:report_id/:view/modal/lightbox/:photo_id`} parentPath={match=>pathToRegexp.compile(`/app/reports/:report_id/:view`)(match.params)} />
                    {/* LEGACY @TODO */}
                    <ModalRoute component={ModalReportPhotosLightbox} exact path={`/app/legacy/reports/:report_id/:view/modal/lightbox/:photo_id`} parentPath={match=>pathToRegexp.compile(`/app/reports/:report_id/:view`)(match.params)} />
                    <ModalRoute component={LegacyModalAssignReportToUser} exact path={`/app/legacy/reports/modal/assign-user/:report_id`} parentPath={`/app/legacy/reports`} />
                    <ModalRoute component={LegacyModalCreateReport} exact path={`/app/legacy/reports/modal/create-report`} parentPath={`/app/legacy/reports`} />
                    {/* END LEGACY @TODO */}
                </Switch>
                <ModalContainer className="react-router-modal-container"/>
            </div>
        </ConnectedRouter>
    </Provider>
)

export default hot(App);